import { useContext, useCallback } from 'react'
import styled from '@emotion/styled'
import { t } from '@lingui/core/macro'
import WarningIcon from '@mui/icons-material/Warning'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Grid from '@mui/material/Grid'
import { colors } from '@global/constants'
import { templateCopyContext } from '../../../context'

const WarningContainer = styled.div`
  margin: 0 0 20px 0;
  width: 100%;
  border-radius: 4px;
  display: flex;
  padding: 12px 24px;
  align-items: flex-start;
  background:
    linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)),
    ${colors.yellow.warning};
`

const WarningText = styled.div`
  font-size: 10px;
  margin-left: 10px;
`

const WarningHeader = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
`

interface BitlyWarningProps {
  assignment: any
  customBitlyEnabled: boolean
}

export const BitlyWarning = ({ assignment, customBitlyEnabled }: BitlyWarningProps) => {
  const { onChange } = useContext(templateCopyContext) as { onChange: (old: any) => void }

  const onBitlyMetadataChange = useCallback(
    value => {
      onChange(old => ({
        ...old,
        [assignment.id]: {
          ...old[assignment.id],
          metadata: {
            ...old[assignment.id].metadata,
            ...value,
          },
        },
      }))
    },
    [onChange, assignment],
  )

  return (
    <>
      <Grid item xs={6}>
        <FormControlLabel
          style={{ margin: 0, height: 70, alignItems: 'center' }}
          onChange={(_, newVal) => {
            onBitlyMetadataChange({ custom_bitlink_enabled: newVal })
          }}
          checked={customBitlyEnabled}
          control={<Checkbox style={{ padding: 2, marginRight: 5 }} color="secondary" />}
          label={t`Customize the back-half of shortened bitly links from this template`}
        />
      </Grid>
      {customBitlyEnabled && assignment.metadata.shortened_url === 'bit.ly' && (
        <WarningContainer>
          <WarningIcon style={{ color: colors.orange.main }} />
          <WarningText>
            <WarningHeader>{t`Warning`}</WarningHeader>
            {t`Custom values used as the Bitly back-halfs are more likely to be taken when using the default bit.ly domain. We recommend using a branded short domain when customizing your Bitly links.`}
          </WarningText>
        </WarningContainer>
      )}
    </>
  )
}
